import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserCountStateService {
  private readonly _userCount$ = new BehaviorSubject<number | null>(1);

  readonly userCount$ = this._userCount$.asObservable();

  setUserCount(count: number | null) {
    // Normalize: minimum 1 when provided
    if (count == null || isNaN(count as any)) {
      this._userCount$.next(null);
      return;
    }
    const normalized = Math.max(1, Math.floor(Number(count)));
    this._userCount$.next(normalized);
  }

  get current(): number | null {
    return this._userCount$.value;
  }
}
